<!--限速区域设置-->
<template>
  <div style="height: 100%; text-align: left">
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('arealimitset.tab1')" name="first"></el-tab-pane>
        <el-tab-pane :label="$t('arealimitset.tab2')" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <el-row style="height: 100%">
      <el-col :span="8" style="height: 100%">
        <div
          style="
            border: 1px solid #c5d0e2;
            height: calc(100vh - 230px);
            margin-right: 16px;
            border-radius: 4px;
            padding: 16px;
          "
        >
          <div v-if="activeName == 'first'">
            <limitareaset_arealist :map="map" />
          </div>

          <div v-if="activeName == 'second'">
            <limitareaset_vehiclelist :map="map" />
          </div></div
      ></el-col>
      <el-col :span="16"
        ><div
          style="
            width: 100%;
            height: calc(100vh - 200px);
            background-color: #fff;
          "
        >
          <KingLongMap
            ref="map"
            mapId="content_0"
            @LoadCompleted="MapLoadCompleted"
          /></div
      ></el-col>
    </el-row>
  </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap.vue";

import limitareaset_arealist from "./limitareaset_arealist";
import limitareaset_vehiclelist from "./limitareaset_vehiclelist";

export default {
  components: {
    KingLongMap,
    limitareaset_vehiclelist,
    limitareaset_arealist,
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },
  },
  data() {
    return {
      date: [],
      activeName: "first",
      map: undefined,
    };
  },
  mounted() {
    //查询区域列表
  },
  methods: {
    MapLoadCompleted() {
      this.map = this.$refs.map;
    },
  },
};
</script>

<style lang=""></style>
